import { SIN_HALF_FOV, roomConstants } from "../constants";

export const calcRoomDepth = (length: number, height: number) => {
    const maxSize = Math.max(length / 2, height / 2);
    const distance = Math.abs(maxSize / SIN_HALF_FOV) + 1500;

    return distance > roomConstants.maxSize.depth ? roomConstants.maxSize.depth : Math.round(distance);
};
